import request from '../commons';
import { AppConfig } from 'shared/app.config';

function getRoles() {
  const req = request.get(AppConfig.api_url)('v3/public/roles');
  return req;
}

export { getRoles };
